import {Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {NgClass, NgFor, NgIf} from '@angular/common';

@Component({
    selector: 'app-admin-process',
    templateUrl: './admin-process.component.html',
    styleUrls: ['./admin-process.component.scss'],
    standalone: true,
    imports: [NgFor, RouterLink, NgClass, NgIf]
})
export class ServicesComponent implements OnInit {

  services = [
    {name: 'Logement', url: '/admin/properties/list', class: 'housing', icon: true,},
    {name: 'Attestation', url: '/admin/attestation', class: 'attestation'},
    {name: 'Bookings', url: '/admin/bookings/list', class: 'housing', icon: true,},
    {name: 'Leads', url: '/admin/leads', class: 'housing', icon: true,},
  ];

  constructor() { }

  ngOnInit(): void {
  }
}
